module.exports = __webpack_public_path__ + "img/logo-rozenbal.2f4569cc.png";